import { SmartDataTable } from '@src/components/SmartDataTable';
import { useSuppliersColumns, useSuppliersFormFields } from './hooks';

export const SuppliersPage = () => {
  const columns = useSuppliersColumns();
  const formFields = useSuppliersFormFields();

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <SmartDataTable
        api={{
          resource: 'suppliers',
        }}
        title="Suppliers"
        columns={columns}
        search={{
          enabled: true,
          fields: ['name', 'email', 'phone'],
          placeholder: 'Search by name, email, or phone...',
          debounceMs: 500,
        }}
        createForm={{
          fields: formFields as any,
          title: 'Add New Supplier',
          submitText: 'Add Supplier',
        }}
        editForm={{
          fields: formFields as any,
          title: 'Edit Supplier',
          submitText: 'Save Changes',
        }}
        formDisplayMode="modal"
        showCreate={true}
        showEdit={true}
        showDelete={true}
        showView={false}
        pageSize={10}
        showSizeChanger={true}
        showQuickJumper={false}
        // showExport={true}
        showColumnVisibility={true}
        tableProps={{
          scroll: {
            x: 'max-content',
            y: 'calc(100vh - 300px)',
          },
        }}
        rowKey="id"
        style={{
          width: '100%',
          overflow: 'hidden',
        }}
      />
    </div>
  );
};
